import React, { useState } from 'react';
import VideoAbout from '../../views/Home/components/VideoAbout';
import ResponsiveContainer from '../../layouts/ResponsiveContainer';
import clsx from 'clsx';
import BackButton from '../Buttons/BackButton';

interface Media {
    type: 'image' | 'video' | '';
    src: string;
    url: string;
    alt: string;
    className: string;
}

interface IHero {
    breadcrumbs: React.ReactNode;
    title: string;
    paragraph: string;
    media: Media;
    layout: 'column' | 'row';
    contentContainerClassName?: string;
    backgroundClassName?: React.CSSProperties;
    imageContainerClassName?: React.CSSProperties;
    buttonGoBack?: boolean;
    handleOnClickGoBack?: () => void;
    expandableDescription?: boolean;
    descriptionClassName?: string;
    buttonExpandableDescriptionClassName?: string;
    containerHeightClassName?: string;
    customMedia?: React.ReactNode;
    titleClassName?: string;
}

const Hero = ({
    breadcrumbs,
    title,
    paragraph,
    media,
    layout,
    contentContainerClassName,
    backgroundClassName = { backgroundColor: '#E4FFF9' },
    buttonGoBack = false,
    handleOnClickGoBack,
    expandableDescription = false,
    descriptionClassName = '',
    buttonExpandableDescriptionClassName = '',
    containerHeightClassName = 'h-[46.875rem]',
    customMedia,
    titleClassName = 'text-primary-10'
}: IHero) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const shouldTruncate = expandableDescription && !isExpanded;
    const truncatedParagraph = paragraph.length > 226 ? paragraph.slice(0, 226) + '...' : paragraph;

    return (
        <div className={`${media.type === 'video' || customMedia || media?.type === 'image' ? '' : containerHeightClassName} relative`}>
            <div className={`${containerHeightClassName} absolute w-full`} style={backgroundClassName}> </div>
            <div className="flex justify-center h-full">
                <ResponsiveContainer className={`pt-14 xl:pt-20 flex ${contentContainerClassName} items-center gap-8 justify-between`}>
                    <div
                        className={clsx('z-10 h-full', {
                            'w-full xl:w-[34.5rem]': (media.type === 'video') && layout === 'row',
                            'w-full': (customMedia && layout === 'row'),
                        })}
                    >
                        {buttonGoBack && (
                            <BackButton
                                onBeforeNavigate={handleOnClickGoBack}
                            />
                        )}
                        {breadcrumbs}
                        <h1 className={`text-dsmall md:text-dmedium pt-2 pb-2 md:pb-5 ${titleClassName}`}>{title}</h1>
                        <p className={`text-blarge text-primary-10 whitespace-pre-line ${descriptionClassName}`}>
                            {shouldTruncate ? truncatedParagraph : paragraph}
                            {expandableDescription && paragraph.length > 226 && (
                                <button
                                    className={`text-primary-40 text-llarge font-medium ml-2 ${buttonExpandableDescriptionClassName}`}
                                    onClick={() => setIsExpanded(!isExpanded)}
                                >
                                    {isExpanded ? 'Ver menos' : 'Ver más'}
                                </button>
                            )}
                        </p>
                    </div>
                    {customMedia ? (
                        <div className="relative z-20">{customMedia}</div>
                    ) : media?.type === 'video' ? (
                        <VideoAbout url={media.url} />
                    ) : media?.type === 'image' ? (
                        <div className="relative z-20 shrink-0">
                            <img src={media.src} alt={media.alt} className={media.className} />
                        </div>
                    ) : null}
                </ResponsiveContainer>
            </div >
        </div >
    );
};

export default Hero;